import { render, staticRenderFns } from "./addStaffSnapshot.vue?vue&type=template&id=ed4ebd46"
import script from "./addStaffSnapshot.vue?vue&type=script&lang=js"
export * from "./addStaffSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports